import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
/** Displays the patient's preferred languages, or "Unavailable" when none are set. */
export function PreferredLanguage(_ref) {
  var languages = _ref.languages;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-base-secondary"
  }, t("patient_preferred_language", {
    defaultValue: "Patient preferred language"
  }), ":", " ", /*#__PURE__*/React.createElement("span", {
    className: "text-sds-base-default"
  }, languages.length > 0 ? languages.join(", ") : t("unavailable", {
    defaultValue: "Unavailable"
  })));
}